import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { MatDialog } from "@angular/material";
import * as moment from "moment";
import { NotificationsService } from "angular2-notifications";
import { ColDef, GridOptions, GridApi, ColumnApi } from "ag-grid-community";
import { UserService } from "../services/user.service";
import { OfframpService } from "../services/offramp.service";
import { ProperJsonDialogComponent } from "../properJsonDialog/properjsondialog.component";
import { TableUtil } from "../admintrademaster/tableUtil";
import { AdjustPayoutWalletDialog } from "./adjust-payout-wallet/adjust-payout-wallet.component";
import { wholeAmountFormatter } from "../custompipes/amount-formatter";

@Component({
  selector: "app-payout-wallet",
  templateUrl: "./payout-wallet.component.html",
  styleUrls: ["./payout-wallet.component.css"],
})
export class PayoutWalletComponent implements OnInit {
  _csrf: string;

  private gridApi: GridApi;
  private gridColumnApi: ColumnApi;
  gridOptions: GridOptions;
  columnDefs: ColDef[] = [];
  rowData: any[] = [];
  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1,
    minWidth: 100,
  };

  wallets: any[] = [];
  searchValue: string = "";
  filter: any = {
    userId: "",
  };

  userList: any[] = [];
  filteredUserList: any[] = [];
  userSearchValue: string = "";

  totalBalance: number = 0;

  constructor(
    private router: Router,
    private notifSer: NotificationsService,
    private userService: UserService,
    private offrampService: OfframpService,
    private spinnerService: Ng4LoadingSpinnerService,
    public dialog: MatDialog
  ) {
    this.initializeGrid();
  }

  ngOnInit() {
    this.csrf();
  }

  loadUserList() {
    if (!this._csrf) {
      return;
    }

    const filter = {
      _csrf: this._csrf,
      perpage: 10000,
      page: 1,
      search: "",
      status: "Active",
    };

    this.offrampService.getOfframpCustomerList(filter).subscribe(
      (response: any) => {
        if (response && response.customers && Array.isArray(response.customers)) {
          this.userList = response.customers;
        } else if (response && Array.isArray(response)) {
          this.userList = response;
        } else if (response && response.data && Array.isArray(response.data)) {
          this.userList = response.data;
        } else {
          this.userList = [];
        }
        this.filteredUserList = this.userList;
      },
      () => {
        this.userList = [];
        this.filteredUserList = [];
      }
    );
  }

  initializeGrid() {
    this.columnDefs = [
      {
        headerName: "Action",
        field: "action",
        cellRenderer: (params) => {
          const element = params.data;
          const container = document.createElement("div");
          container.style.display = "flex";
          container.style.alignItems = "center";

          const viewBtn = document.createElement("button");
          viewBtn.type = "button";
          viewBtn.className = "btn btn-sm btn-info";
          viewBtn.title = "View";
          viewBtn.style.marginRight = "5px";
          viewBtn.innerHTML = '<i class="fa fa-eye"></i>';
          viewBtn.onclick = (e) => {
            e.stopPropagation();
            this.displayProperJson(element, "Payout Wallet");
          };
          container.appendChild(viewBtn);

          const ledgerBtn = document.createElement("button");
          ledgerBtn.type = "button";
          ledgerBtn.className = "btn btn-sm btn-primary";
          ledgerBtn.title = "View Ledger";
          ledgerBtn.style.marginRight = "5px";
          ledgerBtn.innerHTML = '<i class="fa fa-list"></i>';
          ledgerBtn.onclick = (e) => {
            e.stopPropagation();
            this.viewLedger(element);
          };
          container.appendChild(ledgerBtn);

          const adjustBtn = document.createElement("button");
          adjustBtn.type = "button";
          adjustBtn.className = "btn btn-sm btn-warning";
          adjustBtn.title = "Adjust Balance";
          adjustBtn.style.marginRight = "5px";
          adjustBtn.innerHTML = '<i class="fa fa-balance-scale"></i>';
          adjustBtn.onclick = (e) => {
            e.stopPropagation();
            this.openAdjustDialog(element);
          };
          container.appendChild(adjustBtn);

          return container;
        },
        sortable: false,
        filter: false,
        flex: 1,
        minWidth: 160,
      },
      {
        headerName: "User",
        field: "UserId.name",
        valueGetter: (params) => {
          if (params.data && params.data.UserId && params.data.UserId.name) {
            return params.data.UserId.name;
          }
          return "";
        },
        flex: 1.5,
      },
      { headerName: "Currency", field: "Currency", flex: 1 },
      {
        headerName: "Balance",
        field: "Balance",
        flex: 1,
        valueFormatter: wholeAmountFormatter,
        cellStyle: (params) => (params.value <= 0 ? { background: "#ffe6e6" } : null),
      },
      { headerName: "Total Credit", field: "TotalCredit", flex: 1, valueFormatter: wholeAmountFormatter },
      { headerName: "Total Debit", field: "TotalDebit", flex: 1, valueFormatter: wholeAmountFormatter },
      { headerName: "Active", field: "IsActive", flex: 1 },
      {
        headerName: "Last Updated",
        field: "updatedAt",
        valueFormatter: (params) => {
          if (params.value) {
            return moment(params.value).format("MMM DD, YYYY hh:mm:ss A");
          }
          return "";
        },
        flex: 1.5,
      },
      {
        headerName: "CreatedAt",
        field: "createdAt",
        valueFormatter: (params) => {
          if (params.value) {
            return moment(params.value).format("MMM DD, YYYY hh:mm:ss A");
          }
          return "";
        },
        flex: 1.5,
      },
    ];

    this.gridOptions = {
      columnDefs: this.columnDefs,
      defaultColDef: this.defaultColDef,
      rowData: this.rowData,
      pagination: false,
      suppressHorizontalScroll: false,
      enableRangeSelection: true,
      enableCellTextSelection: true,
      ensureDomOrder: true,
      animateRows: true,
      rowHeight: 40,
      headerHeight: 40,
    };
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }

  csrf() {
    this.userService.csrf().subscribe(
      (success) => {
        this._csrf = success._csrf;
        this.loadUserList();
        this.getData();
      },
      (error) => {
        this.notifSer.error("Error", error.error.message, {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50,
        });
      }
    );
  }

  applyFilter(filterValue) {
    this.searchValue = filterValue || "";
    if (this.gridApi) {
      this.gridApi.setQuickFilter(this.searchValue);
    }
  }

  clearSearch() {
    this.searchValue = "";
    this.applyFilter("");
  }

  getData() {
    this.spinnerService.show();
    this.filter._csrf = this._csrf;
    this.userService.getAllPayoutWallets(this.filter).subscribe(
      (list: any) => {
        this.wallets = list || [];
        this.rowData = this.wallets;
        this.totalBalance = this.wallets.reduce((sum, w) => sum + (w.Balance || 0), 0);

        if (this.gridApi) {
          this.gridApi.setRowData(this.rowData);
          this.gridApi.setQuickFilter(this.searchValue || "");
        }
        this.spinnerService.hide();
      },
      () => {
        this.notifSer.error("Error", "Failed to load payout wallets", {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50,
        });
        this.spinnerService.hide();
      }
    );
  }

  exportArray() {
    if (!this.wallets || this.wallets.length === 0) {
      this.notifSer.info("Info", "No data available to export", {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50,
      });
      return;
    }
    const exportData = this.wallets.map((x: any) => ({
      ...x,
      UserId: x.UserId ? x.UserId._id : "",
      UserName: x.UserId ? x.UserId.name : "",
    }));
    TableUtil.exportArrayToExcel(exportData, "PayoutWallet");
  }

  openAdjustDialog(wallet: any) {
    const dialogRef = this.dialog.open(AdjustPayoutWalletDialog, {
      width: "600px",
      maxWidth: "90vw",
      disableClose: true,
      data: { wallet: wallet, _csrf: this._csrf },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.success) {
        const notify = result.pending ? this.notifSer.info.bind(this.notifSer) : this.notifSer.success.bind(this.notifSer);
        notify(result.pending ? "Submitted" : "Success", result.message, {
          timeOut: 5000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 150,
        });
        this.getData();
      }
    });
  }

  viewLedger(wallet: any) {
    const userId = wallet && wallet.UserId ? wallet.UserId._id || wallet.UserId : "";
    this.router.navigate(["payout-ledger"], { queryParams: { userId: userId } });
  }

  displayProperJson(jsonData, eventType) {
    const obj = {
      jsonData: jsonData,
      eventType: eventType || "Payout Wallet",
    };
    this.dialog
      .open(ProperJsonDialogComponent, {
        width: "auto",
        height: "auto",
        data: obj,
      })
      .afterClosed()
      .subscribe(() => { });
  }

  resetFilters() {
    this.filter = {
      userId: "",
    };
    this.searchValue = "";
    this.userSearchValue = "";
    this.filteredUserList = this.userList;
    if (this.gridApi) {
      this.gridApi.setQuickFilter("");
    }
    this.getData();
  }

  onUserSelectOpened(isOpen: boolean) {
    this.userSearchValue = "";
    this.filteredUserList = this.userList;
    if (isOpen) {
      setTimeout(() => {
        this.addSearchToSelectPanel();
      }, 150);
    }
  }

  addSearchToSelectPanel() {
    const panel = document.querySelector(".user-select-panel-payout-wallet-list");
    if (panel) {
      const existingSearch = panel.querySelector(".user-search-container");
      if (existingSearch) {
        existingSearch.remove();
      }

      const searchContainer = document.createElement("div");
      searchContainer.className = "user-search-container";
      searchContainer.innerHTML = `
        <input type="text" placeholder="Search user..." class="user-search-input" value="${this.userSearchValue || ""}">
      `;

      const searchInput = searchContainer.querySelector(".user-search-input") as HTMLInputElement;
      if (searchInput) {
        searchInput.addEventListener("input", (e: any) => {
          this.userSearchValue = e.target.value;
          this.filterUsers(e);
        });
        searchInput.addEventListener("click", (e: any) => {
          e.stopPropagation();
        });
        searchInput.addEventListener("keydown", (e: any) => {
          e.stopPropagation();
        });
      }

      if (panel.firstChild) {
        panel.insertBefore(searchContainer, panel.firstChild);
      } else {
        panel.appendChild(searchContainer);
      }

      if (searchInput) {
        setTimeout(() => {
          searchInput.focus();
        }, 50);
      }
    }
  }

  filterUsers(event: any) {
    const searchTerm = event ? (event.target ? event.target.value : event) : this.userSearchValue;
    this.userSearchValue = searchTerm || "";

    if (!searchTerm || searchTerm.trim() === "") {
      this.filteredUserList = this.userList;
      return;
    }

    const term = searchTerm.toLowerCase();
    this.filteredUserList = this.userList.filter((user) => {
      const name = (user.name || "").toLowerCase();
      const email = (user.email || "").toLowerCase();
      return name.includes(term) || email.includes(term);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/payout-wallet/payout-wallet.component.ts